export default __webpack_public_path__ + "static/media/example-patekphilippe-IMG.ea4a3946.jpg";